import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {KeolisSpinner} from '../containers/common/commonExport';

class AuthComponent extends React.Component {
    constructor(props){
        super(props);
    }
    render(){
        const errorMsg = this.props.message? this.props.message : this.props.errMsg;
        return this.props.isError ? <div className='authHead error'>{"Authentication failed : " + errorMsg}</div> : <KeolisSpinner />;
    }
}
function mapStateToProps(state) {
    return { 
        isError:state.isAzureError,
        errMsg:state.azureErrMsg
    };
}
export default connect(mapStateToProps, null)(AuthComponent);